import { render, staticRenderFns } from "./TrialStepRequirementsWindows.vue?vue&type=template&id=228c34e8&scoped=true&"
import script from "./TrialStepRequirementsWindows.vue?vue&type=script&lang=ts&"
export * from "./TrialStepRequirementsWindows.vue?vue&type=script&lang=ts&"
import style0 from "./TrialStepRequirementsWindows.vue?vue&type=style&index=0&id=228c34e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c34e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228c34e8')) {
      api.createRecord('228c34e8', component.options)
    } else {
      api.reload('228c34e8', component.options)
    }
    module.hot.accept("./TrialStepRequirementsWindows.vue?vue&type=template&id=228c34e8&scoped=true&", function () {
      api.rerender('228c34e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/trial/TrialStepRequirementsWindows.vue"
export default component.exports